export interface PlanFeature {
  product: string
  features: string[]
}

export interface Plan {
  name: string
  category: 'Enterprise' | 'K-12'
  description: string
  productFeatures: PlanFeature[]
}

export const plansData: Plan[] = [
  {
    name: 'Basic',
    category: 'Enterprise',
    description: 'Essential online giving and email outreach',
    productFeatures: [
      {
        product: 'Online Giving',
        features: ['Smart Ask Amounts', 'Personalization', 'Smart Segments'],
      },
      {
        product: 'Outreach',
        features: ['Email Outreach', 'Smart Segments'],
      },
    ],
  },
  {
    name: 'Advanced',
    category: 'Enterprise',
    description: 'Complete platform with texting and wealth screening',
    productFeatures: [
      {
        product: 'Online Giving',
        features: [
          'Smart Ask Amounts',
          'Personalization',
          'Smart Segments',
          'Wealth Alerts',
        ],
      },
      {
        product: 'Outreach',
        features: ['Email Outreach', 'Texting', 'Smart Segments'],
      },
      {
        product: 'Wealth',
        features: ['Core', 'Wealth Alerts'],
      },
    ],
  },
]

export function getPlanNames(): string[] {
  return plansData.map((plan) => plan.name)
}

export function getPlanByName(name: string): Plan | undefined {
  return plansData.find((plan) => plan.name === name)
}

export function getPlansByCategory(category: 'Enterprise' | 'K-12'): Plan[] {
  return plansData.filter((plan) => plan.category === category)
}
